module.exports = __webpack_public_path__ + "img/chip.743f574.png";